/* import __COLOCATED_TEMPLATE__ from './last-updated-at-cell.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import type ContentWrapper from 'embercom/models/content-service/content-wrapper';

interface Args {
  contentWrapper: ContentWrapper;
}

export default class LastUpdatedAtCell extends Component<Args> {
  get lastUpdatedAt(): Date {
    return this.args.contentWrapper.contents.firstObject!.updatedAt;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentService::AiContentLibrary::List::Cells::LastUpdatedAtCell': typeof LastUpdatedAtCell;
  }
}
